export { default } from './element-queries';



// WEBPACK FOOTER //
// ./default-modules/ui/core/element-queries/index.ts